import { memo } from 'react';

import { ExecuteSubmissionResponse } from '@scale/shared/sphereEngine/types';

import { Tooltip, Icon } from '@scale/scaleui';

interface CodeExecutionResultProps {
  isRunningCodeExecution?: boolean;
  codeExecutionResponse?: ExecuteSubmissionResponse;
}

export const CodeExecutionResult = memo(
  ({ isRunningCodeExecution, codeExecutionResponse }: CodeExecutionResultProps) => {
    const stdout = (codeExecutionResponse?.stdout ?? '').trim();
    const stderr = (codeExecutionResponse?.stderr ?? '').trim();
    return (
      <>
        <div className={'flex items-center justify-between py-2 px-4 border-border border-t'}>
          <div className="text-muted-contrast">{`Output`}</div>
          <Tooltip
            text="Copy output to clipboard"
            target={
              <Icon
                icon="copy"
                onClick={() => {
                  navigator.clipboard.writeText(
                    JSON.stringify(codeExecutionResponse ?? '', null, 2),
                  );
                }}
              />
            }
          />
        </div>
        <div className="pb-2 px-4">
          {isRunningCodeExecution ? (
            <div className="text-muted-contrast">Running code execution...</div>
          ) : stdout || stderr ? (
            <>
              {stdout ? <div className="text-contrast">{stdout}</div> : null}
              {stderr ? <div className="text-error-text">{stderr}</div> : null}
            </>
          ) : codeExecutionResponse ? (
            <div className="text-muted-contrast">{'Ok'}</div>
          ) : null}
        </div>
      </>
    );
  },
);
